import styled from 'styled-components';

export const MainContentWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export const MainContent = styled.div`
  max-width: 468px;
  text-align: center;
`;

export const ChangeMethodTitle = styled.h1`
  ${(p) => p.theme.typography.title};
  margin-bottom: 8px;
`;

export const ChangeMethodBlock = styled.div`
  margin-bottom: 32px;
`;

export const ChangeMethodSubtitle = styled.p`
  font-size: 14px;
  line-height: 24px;
  color: ${(props) => props.theme.colors.muted};
  margin-bottom: 32px;
`;

export const FooterWrapper = styled.div`
  width: 100%;
`;

export const FooterContent = styled.div`
  display: flex;
  justify-content: space-between;
`;
